import axios from "axios"  //引入axios
import qs from "qs"  //这个是axios里面的模块，用于序列化参数的。 看情况使用哦
import { getToken } from "./auth"   //获取到token
import ElementUI from 'element-ui';

//创建一个axios实例
const service = axios.create({
  baseURL: '/apis',
  timeout:50000,
  //transformRequest 这里主要是 post请求时 请求成功了，但是后台并没
  //有获取到前端的请求参数。如果后台是直接从请求体里取的话，请忽略
  // transformRequest:[
  //   data => {
  //     let params = qs.stringify(data, {indices: false})
  //     return params
  //   }
  // ]
})

// 请求超时 请求头
service.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

let token = getToken()  //获取token

// 请求拦截器
service.interceptors.request.use(
  config => {
    if(token){
      //每次请求都需要带上token去请求接口
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

//响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if(res.code == 5000){
      ElementUI.MessageBox.confirm("登录已失效，请重新登录",{
        confirmButtonText: "返回登录页",
        cancelButtonText: "取消",
        type: "warning",
        showClose:false,
        showCancelButton:false,
        closeOnClickModal:false
      }).then(() => {
        //退回到登录页 需要将sessionStorage里面的值给清空掉
        sessionStorage.clear();
        window.location = '/login'
      })
    } else {
      return res;
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service